<template>
  <b-row :class="full ? 'full-row' : 'alert-row'" class="no-gutters" v-if="flagMessagesShown">
    <b-col :cols="full ? 12 : 6" class="m-auto">
      <b-alert
          v-for="(item, i) in ObjAlertState.store"
          :key="i"
          dismissible
          :fade="true"
          v-model="item.startTime"
          @dismissed="ObjAlertState.deleteOne(i)"
          :variant="ObjAlertState.statusClasses[item.status]"
          :class="full ? 'float-left' : 'float-none'"

      >
        <pre v-html="item.text"></pre>
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
import ObjAlertState from "@/components/common/alert/ObjAlertState";

export default {
  props: {
    full: {
      type:    Boolean,
      default: false,
    }
  },
  data() {
    return {
      ObjAlertState: ObjAlertState,
    }
  },
  methods:  {
    ehDeleteAllMessages() {
      ObjAlertState.deleteAll();
    }
  },
  computed: {
    flagMessagesShown: {
      get() {
        return ObjAlertState.store.length > 0;
      },
      // set(v) {
      //   if (!v) {
      //     this.ehDeleteAllMessages();
      //   }
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.alert-row {
  position: fixed;
  top: 60px;
  width: 100%;
  z-index: 9999;
}

.full-row {
  width: 100%;
}

pre {
  background-color: transparent;
  padding: 0;
  margin: 0;
}
</style>
